<template>
  <div class="create-account">
    <div class="is-size-3 login-header">
      {{ $t('authenticator.create_an_account') }}
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.username') }} *</label>
      <div class="control">
        <input
          v-model="$v.user.username.$model"
          class="input is-large"
          type="text"
          autofocus
          :placeholder="$t('authenticator.username')"
        >
      </div>
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.password') }} *</label>
      <div class="control">
        <input
          v-model="$v.user.password.$model"
          class="input is-large"
          type="password"
          :placeholder="$t('authenticator.password')"
        >
      </div>
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.email') }} *</label>
      <div class="control">
        <input
          v-model="$v.user.attributes.email.$model"
          class="input is-large"
          type="email"
          :placeholder="$t('authenticator.email')"
        >
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button
          name="button_lalala"
          class="button is-primary is-large is-broad is-uppercase"
          :class="{'is-loading': isLoading}"
          @click="handleSubmit"
        >
          {{ $t('authenticator.create_account') }}
        </button>
        <p
          class="help"
        >
          {{ $t('authenticator.have_account') }}
          <a
            href="#"
            @click.prevent="$emit('changeAuthState', $options.SIGNED_OUT)"
          >
            {{ $t('authenticator.sign_in') }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SIGNED_OUT, CONFIRM_SIGN_UP } from './auth-actions'
import { mapActions } from 'vuex'
import { username, password, email } from './validation-settings.js'

export default {

  name: 'Login',
  props: {
    validationChecks: {
      type: Array,
      default: () => []
    },
    validationRunner: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      user: {
        username: '',
        password: '',
        attributes: {
          email: ''
        }
      },
      isLoading: false
    }
  },
  created () {
    this.$options.CONFIRM_SIGN_UP = CONFIRM_SIGN_UP
    this.$options.SIGNED_OUT = SIGNED_OUT
  },
  methods: {
    ...mapActions(['handleSession', 'clearSessionData']),
    async handleSubmit () {
      this.isLoading = true
      this.validationRunner(this.$v, this.validationChecks)
      // this.clearSessionData()

      if (!this.$v.$invalid) {
        try {
          const data = await this.$auth.signUp(this.user)
          if (data.userConfirmed === false) {
            this.$emit('changeAuthState', this.$options.CONFIRM_SIGN_UP)
          }
        } catch (err) {
          this.$emit('displayError', err.message)
        }
      }
      this.isLoading = false
    }
  },
  validations: {
    user: {
      username,
      password,
      attributes: {
        email
      }
    }
  }
}
</script>
